//  Version : 0.0.1
//  Author : VISHNU
// LastEdit : KARTHEESWARAN
// LASTADD : Removed excel Redux
// MODFIED DATE:12-11-2025

import { all, call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import {
	getArrearFollowupDetailsFailure,
	getArrearFollowupDetailsResponseChanged,
	getArrearFollowupDetailsSuccess,
} from './arrear-followup-report.action';
import ArrearFollowupActionTypes from './arrear-followup-report.type';
import { ArrearFollowupListGet } from './arrear-followup-report.service';

/*************** GET ARREAR FOLLOWUP LIST START ************/
export function* getArrearFollowupList({ payload }: any) {
	try {
		const {
			companyID,
			branchID,
			databaseName,
			month,
			year,
			viewBy,
			isThriftExist,
			userID,
			userLevel,
			requestID,
			generalCompanyID,
			viewType,
			loanType,
		} = payload;
		const key = 'GetArrearFollowUpReportKey';
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			Month: month,
			Year: year,
			ViewBy: viewBy,
			IsThriftExist: isThriftExist,
			UserID: userID,
			UserLevel: userLevel,
			RequestID: requestID,
			generalCompanyID: generalCompanyID,
			viewType: viewType,
			loanType: loanType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(ArrearFollowupListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getArrearFollowupDetailsFailure(responseData.data));
		} else {
			yield put(getArrearFollowupDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getArrearFollowupDetailsFailure(error));
	}
}

export function* resetGetArrearFollowupListResponse() {
	yield put(getArrearFollowupDetailsResponseChanged());
}

export function* onGetArrearFollowupListDetails() {
	yield takeLatest(
		ArrearFollowupActionTypes.GET_ARREAR_FOLLOWUP_LIST_START,
		getArrearFollowupList,
	);
}

export function* onGetArrearFollowupListResponseReset() {
	yield takeLatest(
		ArrearFollowupActionTypes.GET_ARREAR_FOLLOWUP_LIST_RESPONSE_RESET,
		resetGetArrearFollowupListResponse,
	);
}
/*************** GET ARREAR FOLLOWUP LIST END ************/

export function* arrearFollowupReportSaga() {
	yield all([call(onGetArrearFollowupListDetails), call(onGetArrearFollowupListResponseReset)]);
}
